export const campaignSiteUploadUrl = "/api/v3/campaign/upload";
export const campaignMediaUploadUrl =
  "/api/v3/campaign/:campaignId/media/upload";
export const getCampaignTemplateUrl = "/api/v3/campaign/media/template";
